var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useState } from 'react';
import cx from 'classnames';
import { FormField as SemanticFormField, } from 'semantic-ui-react';
import Grid from '../Grid/Grid';
const hasValueProp = (props) => {
    // eslint-disable-next-line no-prototype-builtins
    return props.hasOwnProperty('value');
};
const canCalculateLength = (value) => {
    return typeof value === 'string';
};
const getDefaultValue = (multiple = false) => {
    return multiple ? [] : '';
};
export const FormField = React.forwardRef((props, ref) => {
    const { outline, floatLabel, className, hint, error, maxLength, value: propsValue, defaultValue, onChange, onFocus, onBlur } = props, rest = __rest(props, ["outline", "floatLabel", "className", "hint", "error", "maxLength", "value", "defaultValue", "onChange", "onFocus", "onBlur"]);
    const [focused, setFocused] = useState(false);
    const [pristine, setPristine] = useState(true);
    const [stateValue, setStateValue] = useState(defaultValue !== null && defaultValue !== void 0 ? defaultValue : getDefaultValue(props.multiple));
    const isControlledComponent = hasValueProp(props);
    const value = isControlledComponent ? propsValue : stateValue;
    const handleChange = useCallback((evt, changeProps) => {
        const { value: propsChangeValue } = changeProps || {};
        const changeValue = changeProps && hasValueProp(changeProps) ? propsChangeValue : evt.currentTarget.value;
        if (maxLength && canCalculateLength(changeValue) && changeValue.length > maxLength) {
            return;
        }
        setPristine(false);
        if (!isControlledComponent) {
            setStateValue(changeValue);
        }
        if (onChange) {
            onChange(evt, changeProps);
        }
    }, [maxLength, onChange, isControlledComponent]);
    const handleFocus = useCallback((evt) => {
        setFocused(true);
        if (onFocus) {
            onFocus(evt);
        }
    }, [onFocus]);
    const handleBlur = useCallback((evt) => {
        setFocused(false);
        if (onBlur) {
            onBlur(evt);
        }
    }, [onBlur]);
    const classes = cx({
        outline: !!outline,
        focused: !!focused,
        hinted: !!hint,
        filled: floatLabel || (pristine && !!props.defaultValue) || !!value,
        icon: !!props.icon,
        left: props.iconPosition === 'left',
    });
    return (React.createElement("div", { ref: ref, className: cx('wrapper', className) },
        React.createElement(SemanticFormField, Object.assign({}, rest, { value: value, className: classes, error: error, maxLength: maxLength, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur })),
        hint || (maxLength && canCalculateLength(value)) ? (React.createElement("div", { className: cx('hint', error && 'error') },
            React.createElement(Grid, { columns: "equal" },
                React.createElement(Grid.Column, null, hint),
                maxLength && canCalculateLength(value) ? (React.createElement(Grid.Column, { width: 1, textAlign: "right", floated: "right" }, `${value.length}/${maxLength}`)) : null))) : null));
});
export default FormField;
//# sourceMappingURL=FormField.js.map